import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import { Button, Typography, useMediaQuery } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const BaseAuth = () => {
  const isMd = useMediaQuery("(min-width:756px)");
  const navigate = useNavigate();
  const { themeDisplay } = useSelector((state) => state.ThemeToggler);

  return (
    <div className="-mt-1 relative h-[100vh]">
      {isMd ? (
        <>
          {themeDisplay === "blue" ? (
            <img
              className="md:max-h-[60vh] md:w-[100vw] md:object-cover"
              src="/assets/images/login/2-01.svg"
              alt=""
            />
          ) : themeDisplay === "green" ? (
            <img
              className="md:max-h-[90vh] md:w-[100vw] md:object-cover"
              src="/assets/images/login/3-01.svg"
              alt=""
            />
          ) : themeDisplay === "orange" ? (
            <img
              className="md:max-h-[90vh] md:w-[100vw] md:object-cover"
              src="/assets/images/login/4-01.svg"
              alt=""
            />
          ) : themeDisplay === "dark" ? (
            <img
              className="md:max-h-[90vh] md:w-[100vw] md:object-cover"
              src="/assets/images/login/5-01.svg"
              alt=""
            />
          ) : (
            <img
              className="md:max-h-[90vh] md:w-[100vw] md:object-cover"
              src="/assets/images/login/1-01.svg"
              alt=""
            />
          )}
        </>
      ) : (
        <>
          {themeDisplay === "blue" ? (
            <img
              className="md:max-h-[60vh] md:w-[100vw] md:object-cover"
              src="/assets/images/login/2.svg"
              alt=""
            />
          ) : themeDisplay === "green" ? (
            <img
              className="md:max-h-[60vh] md:w-[100vw] md:object-cover"
              src="/assets/images/login/3.svg"
              alt=""
            />
          ) : themeDisplay === "orange" ? (
            <img
              className="md:max-h-[60vh] md:w-[100vw] md:object-cover"
              src="/assets/images/login/4.svg"
              alt=""
            />
          ) : themeDisplay === "dark" ? (
            <img
              className="md:max-h-[60vh] md:w-[100vw] md:object-cover"
              src="/assets/images/login/5.svg"
              alt=""
            />
          ) : (
            <img
              className="md:max-h-[60vh] md:w-[100vw] md:object-cover"
              src="/assets/images/login/1.svg"
              alt=""
            />
          )}
        </>
      )}
      <div className="absolute top-[110px] right-1/2 translate-x-1/2 bg-white p-2 rounded-md flex flex-col gap-3">
        <img
          src="/assets/images/logo.png"
          alt=""
          className="md:w-[130px] w-[100px] "
        />
      </div>
      <h1 className="absolute top-[240px] right-1/2 translate-x-1/2 text-white text-center font-bold text-lg">
        {process.env.REACT_APP_TITLE}
      </h1>
      <div className="flex absolute bottom-28 left-1/2 -translate-x-1/2  flex-col gap-4 justify-center items-center">
        <Button
          sx={{ width: "200px !important", height: "48px !important" }}
          onClick={() => navigate("/login")}
          variant="contained"
          color="primary"
        >
          ورود
        </Button>
        <Button
          sx={{
            width: "200px !important",
            height: "48px !important",
            background: (theme) =>
              theme.palette.mode === "dark"
                ? "#000 !important"
                : "#fff !important",
          }}
          onClick={() => navigate("/singup")}
          variant="contained"
          color="inherit"
        >
          ثبت نام {/* کابر */}
        </Button>
        {/* <Button
          sx={{
            width: "200px !important",
            height: "48px !important",
          }}
          onClick={() => navigate("/register-modi")}
          variant="outlined"
          color="primary"
        >
          ثبت نام مودی
        </Button> */}
      </div>{" "}
      <Box
        sx={{
          display: "flex",
          gap: 1,
          alignItems: "center",
          justifyContent: "space-between",
        }}
        className=" absolute bottom-0 right-1/2 translate-x-1/2"
      >
        <SupportAgentIcon sx={{ color: "#20a8d8" }} />
        <div className="flex flex-col items-end gap-1">
          <Typography
            component={"a"}
            href={`tel:${process.env.REACT_APP_TEL1}`}
            sx={{
              fontSize: "1rem",
              color: "#20a8d8",
              fontWeight: "bold",
            }}
          >
            {process.env.REACT_APP_TEL1}
          </Typography>{" "}
          <Typography
            component={"a"}
            href={`tel:${process.env.REACT_APP_TEL2}`}
            sx={{
              fontSize: "1rem",
              color: "#20a8d8",
              fontWeight: "bold",
              /*                         ml:"90px"
               */
            }}
          >
            {process.env.REACT_APP_TEL2}
          </Typography>
        </div>
      </Box>
    </div>
  );
};

export default BaseAuth;
